// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDiBr3sLqnJVzj70g1FXPWo8nCznzsmcNc",
    authDomain: "cd-lynparza-game.firebaseapp.com",
    databaseURL: "https://cd-lynparza-game-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "cd-lynparza-game",
    storageBucket: "cd-lynparza-game.appspot.com",
    messagingSenderId: "1009249614304",
    appId: "1:1009249614304:web:400d48d3908308afb0d385",
    measurementId: "G-C7SGJ8SQ77"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);
export const db = getFirestore(firebaseApp);
